import {configurationElement, formField, typeDatabase, typeFormValue} from "./configurationPropertyUtils";
import {ElementParse} from "../ParseClass/Element.Parse";
import {EdgeDeviceType} from "../ParseClass/Iotdevices.Parse";
import {getOnlyValuesEnum} from "../providers/service/global-variables.service";


export const configurationPropertyIotDevicesParse: configurationElement [] =
    [
        {
            keyName: 'createdAt',
            varianteKey: '',
            traductionKey: 'createdAt',
            typeForm: typeFormValue.DATE,
            typeDatabase: typeDatabase.DATE,
            editable: false,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 200,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'updatedAt',
            varianteKey: '',
            traductionKey: 'updatedAt',
            typeForm: typeFormValue.DATE,
            typeDatabase: typeDatabase.DATE,
            editable: false,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 300,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'seriale',
            varianteKey: undefined,
            traductionKey: 'IotDevices.seriale',
            typeForm: typeFormValue.OTHERINHTML,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: true,
            possibleValues: undefined,
            sortingValue: 400,
            section: 0,
            forms: undefined,
            pointer: undefined
        }, {
        keyName: 'type',
        varianteKey: undefined,
        traductionKey: 'IotDevices.type',
        typeForm: typeFormValue.ELENCO_VINCOLATO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: getOnlyValuesEnum(EdgeDeviceType),
        sortingValue: 500,
        section: 0,
        forms: undefined,
        pointer: undefined
    }, {
        keyName: 'environment',
        varianteKey: undefined,
        traductionKey: 'IotDevices.environment',
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined,
        pointer: undefined
    }, {
        keyName: 'simSerial',
        varianteKey: undefined,
        traductionKey: 'IotDevices.simSerial',
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined,
        pointer: undefined
    }, {
        keyName: 'location',
        varianteKey: undefined,
        traductionKey: 'IotDevices.location',
        typeForm: typeFormValue.GEO_POINT,
        typeDatabase: typeDatabase.GEOPOINT,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined,
        pointer: undefined
    }
    ];
